(function () {
  'use strict';

  var nav = document.querySelector('.hof-nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var headerGroup = document.querySelector('#header-group');
  if (headerGroup) {
    var setHeaderGroupHeight = function () {
      var height = 0;
      var children = headerGroup.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i] instanceof HTMLElement) height += children[i].offsetHeight;
      }
      document.body.style.setProperty('--header-group-height', height + 'px');
    };
    setHeaderGroupHeight();
    window.addEventListener('resize', setHeaderGroupHeight);
  }

  var hero = document.querySelector('.hof-hero');
  if (hero) {
    requestAnimationFrame(function () {
      hero.classList.add('is-ready');
    });
  }

  var revealables = document.querySelectorAll('.hof-rv');
  if ('IntersectionObserver' in window && revealables.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    revealables.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealables.forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  var drawer = document.querySelector('.hof-drawer');
  var burger = document.querySelector('.hof-nav__burger');
  if (drawer && burger) {
    burger.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('.hof-drawer__close')) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  document.querySelectorAll('[data-hof-rail]').forEach(function (group) {
    var rail = group.querySelector('.hof-rail');
    var prev = group.querySelector('[data-rail-prev]');
    var next = group.querySelector('[data-rail-next]');
    if (!rail) return;
    var step = function () {
      var first = rail.firstElementChild;
      return first ? first.getBoundingClientRect().width + 10 : 240;
    };
    var sync = function () {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    };
    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step() * 2, behavior: 'smooth' });
      });
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  var toast = document.querySelector('.hof-toast');
  var toastTimer;
  window.hofToast = function (msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-show');
    }, 2200);
  };

  var pdp = document.querySelector('[data-hof-product]');
  if (pdp) {
    var dataEl = pdp.querySelector('[data-hof-variants]');
    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var colorName = (pdp.dataset.colorName || 'Color').toLowerCase();
    var sizeName = (pdp.dataset.sizeName || 'Size').toLowerCase();
    var selected = {};

    var current = variants.find(function (v) {
      return String(v.id) === String(pdp.dataset.currentVariant);
    }) || variants.find(function (v) {
      return v.available;
    }) || variants[0];

    if (current && current.options) {
      var optionNames = (pdp.dataset.optionNames || '').split('|');
      current.options.forEach(function (value, i) {
        var name = (optionNames[i] || '').toLowerCase();
        selected[name] = value;
      });
    }

    var idInput = pdp.querySelector('[name="id"]');
    var priceEl = pdp.querySelector('[data-hof-price]');
    var addBtn = pdp.querySelector('[data-hof-add]');
    var buyNow = pdp.querySelector('[data-hof-buy-now]');
    var mainImg = pdp.querySelector('[data-gallery-main]');

    var findVariant = function () {
      return variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          var name = ((pdp.dataset.optionNames || '').split('|')[i] || '').toLowerCase();
          if (!selected[name]) return true;
          return selected[name] === value;
        });
      });
    };

    var money = function (cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, pdp.dataset.moneyFormat || '{{amount}}');
      }
      return (cents / 100).toFixed(2);
    };

    var applyVariant = function (variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var formatted = money(variant.price);
        var currency = pdp.dataset.currency || '';
        priceEl.innerHTML =
          formatted +
          (currency
            ? ' <span class="hof-price__currency">' + currency + '</span>'
            : '');
      }
      if (addBtn) {
        var label = addBtn.dataset.label || 'Add To Cart';
        addBtn.textContent = variant.available ? label + ' — ' + money(variant.price) : addBtn.dataset.soldOut || 'Sold out';
        addBtn.disabled = !variant.available;
      }
      if (buyNow) {
        buyNow.href = '/cart/' + variant.id + ':1';
        buyNow.toggleAttribute('hidden', !variant.available);
      }
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };

    pdp.querySelectorAll('[data-hof-picker]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || btn.classList.contains('is-oos') || btn.disabled) return;
        group.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-active');
        });
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.add('is-active');
        var key = (group.dataset.hofPicker || '').toLowerCase();
        selected[key] = btn.dataset.value || btn.textContent.trim();
        var out = group.querySelector('[data-picker-out]');
        if (out) out.textContent = selected[key];
        var swap = btn.dataset.image;
        if (swap && mainImg) mainImg.src = swap;
        applyVariant(findVariant());
      });
    });
  }
})();
